import { css } from '@emotion/react';

import { useRouter } from 'next/router';

import { Typography } from 'chatie-design-system';

import EFinderImage from '@components/common/EFinderImage';

import { IPlacardBanner } from '@base/outlookModel';
import { Platform } from '@constants';
import { useGlobalContext } from '@contexts/global';
import { useWebView } from '@utils/webview';

const containerCSS = (data: IPlacardBanner) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${data.height}px;
  background-color: ${data.background_color};
  overflow: hidden;
  position: relative;

  > img {
    width: 100%;
    height: ${data.height}px;
    overflow: hidden;
    position: relative;
  }

  .bannerText {
    ${Typography.h6};
    color: ${data.font_color};
    font-weight: 600;
    z-index: 3;
  }
`;

interface PlaCardBannerProps {
  data: IPlacardBanner;
}

const PlaCardBanner = ({ data }: PlaCardBannerProps) => {
  const router = useRouter();
  const { web } = useWebView();
  const { platform } = useGlobalContext();

  const handleClickCard = () => {
    if (data.url !== '') {
      if (platform === Platform.web) {
        router.push(data.url);
      }
      web.openUrl(data.url);
    }
  };
  return (
    <div onClick={handleClickCard} css={containerCSS(data)}>
      {data?.banner?.image && data?.banner?.image?.key && (
        <EFinderImage image={data?.banner?.image} />
      )}
      <p className="bannerText">{data.title}</p>
    </div>
  );
};

export default PlaCardBanner;
